<script>
  import Section from './Section.svelte';
  import Modal from './Modal.svelte';
  import Slider from './Slider.svelte';
  import InputButton from './InputButton.svelte';
  import CaptureStore from '../stores/capture.store';
  import TroyService from '../services/troy.service';
  import CaptureService from '../services/capture.service';
  import config from '../config.json';
  import Logger from '../helpers/logger';

  const uuidv4 = () => {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  }

  const dataSourceIds = CaptureService.getDataSourceIds();
  dataSourceIds.sort((a, b) => a.name.localeCompare(b.name));

  const events = {
    decodedData:{name: 'Decoded Data' },
    error:{name: 'Error' },
    buttons:{ name: 'Buttons' },
    batteryLevel: { name: 'Battery Level' },
    power: { name: 'Power state' }
  };
  const answersToRequest = TroyService.getAnswersToRequest();
  
  let deviceTypes = CaptureService.getDeviceTypes();
  deviceTypes.sort((a, b) => a.name.localeCompare(b.name));

  let credentialsName = $CaptureStore.credentialsName || Object.keys(config.credentials)[0];
  let appId = config.credentials[credentialsName].appId;
  let developerId = config.credentials[credentialsName].developerId;
  let appKey = config.credentials[credentialsName].appKey;
  let rootProperties = [];
  let captureHandle = $CaptureStore.captureHandle;
  
  // the reverse client can receive a property normally sent to the Root Capture like SocketCamStatus
  let reverseClient = $CaptureStore.reverseClient || {}; // this is the reverse client in the extension
  let troyDevices = $CaptureStore.troyDevices || []; // this is the troy devices created by the extension
  let troyDevicesAndReverseClient = [reverseClient, ...troyDevices];
  
  
  let deviceName = '';
  let deviceGuid = $CaptureStore.deviceGuid || uuidv4();
  let deviceType = '';
  let openCloseLabel = reverseClient.handle ? 'Close' :'Open';
  let dataSourceId;
  let decodedData;
  let deviceSource;
  let error;
  let usingWebSocket = true;
  let devicePropertyRequests = [];
  let troyDeviceSelected;
  let saveAnswerToRequest = false;
  let answerToRequest;
  let lastEventId = $CaptureStore.lastEventId || 0;
  let eventSelected = events.decodedData;
  let batteryLevel = 40;

  const displayError = (err, title) => {
    Logger.log('catch err', err);
    let message = err.message;
    if(err.error){
      message = err.error.message;
    }
    error = {
      title,
      message
    }
  }

  const troyEventsCallback = (eventId) => {
    Logger.log('CaptureExtension receives new event eventId: ', eventId);
    Logger.log('lastId: ', lastEventId);
    const events = TroyService.getTroyEventRequest()
      .filter(e => e.id >= lastEventId)
      .map(e => e.event);
    const notifications = TroyService.getTroyEventNotifications()
      .filter(n => n.id >= lastEventId)
      .map(n => n.event);
    console.log('events: ', events);
    console.log('notifications: ', notifications);
    lastEventId = eventId;
    [...troyDevices, reverseClient].forEach(t => {
      t.propertyRequestResponses = t.propertyRequestResponses || [];
      t.propertyRequestResponses = [...t.propertyRequestResponses, ...events
        .filter(e => e.params.handle === t.handle)
        .map(e => JSON.stringify(e))];
    });
    [...troyDevices, reverseClient].forEach(t => {
      t.notifications = t.notifications || [];
      t.notifications = [...t.notifications, ...notifications
        .filter(e => e.params.handle === t.handle)
        .map(n=> JSON.stringify(n))];
    });
    $CaptureStore.troyDevices = troyDevices;
    $CaptureStore.reverseClient = reverseClient;
    $CaptureStore.lastEventId = eventId;
    console.log('troyDevices: ', troyDevices);
    console.log('reverseClient: ', reverseClient);
  }

  TroyService.setTroyEventNotifyCallback(troyEventsCallback, lastEventId);

  const openCloseReverseClient = async () => {
    if(openCloseLabel === 'Open'){
      try{
        console.log('reverseClient: ', reverseClient);
        reverseClient.handle = await TroyService.openReverseClient(
            appId, developerId, appKey, captureHandle, "global",
            rootProperties.map(p => p.id), usingWebSocket);
        reverseClient.name = 'Reverse Client';
        reverseClient.propertyRequestResponses = [];
        reverseClient.answerToRequest = answersToRequest.find(a => a.selected);
        reverseClient.root = true;
        TroyService.updateReverseClientsList([reverseClient]);
        $CaptureStore.reverseClient = reverseClient;
        openCloseLabel = 'Close';
      }
      catch(err) {
        displayError(err, 'Error Open Reverse Client');
      }
    }
    else{
      const handle = captureHandle;
      captureHandle = undefined;
      try{
        await TroyService.close(reverseClient.handle);
      }
      finally{
        reverseClient.handle = undefined;
        reverseClient.propertyRequestResponses = [];
        $CaptureStore.reverseClient = reverseClient;
        openCloseLabel = 'Open';
        captureHandle = handle;
        troyDevices= [];
      }
    }
  }

  const openTroyDevice = async () => {
    try{
      const deviceHandle = await TroyService.openTroyDevice(reverseClient.handle, deviceName, deviceGuid, deviceType.type);
      troyDevices = [...troyDevices, {
        name: deviceName,
        guid: deviceGuid,
        type: deviceType,
        handle: deviceHandle,
        root: false,
        notifications: [],
        propertyRequestResponses: [],
        answerToRequest: answersToRequest.find(a => a.selected)
      }];
      TroyService.updateTroyDevicesList(troyDevices);
      $CaptureStore.troyDevices = troyDevices;
      deviceName = '';
      deviceGuid = uuidv4();
      $CaptureStore.deviceGuid = deviceGuid;
    }
    catch(err) {
      displayError(err, 'Error Open Troy device');
    }
  }

  const closeTroyDevice = async deviceHandle => {
    try{
      const response = await TroyService.close(deviceHandle);
      const index = troyDevices.findIndex(d => d.handle === deviceHandle);
      if(index!= -1){
        troyDevices.splice(index, 1);
        troyDevices = [...troyDevices];
        $CaptureStore.troyDevices = troyDevices;
        TroyService.updateTroyDevicesList(troyDevices);
      }
    }
    catch(err){
      displayError(err, 'Error Close Troy device');
    }
  }

  const sendTroyEvent = async device => {
    Logger.log('sendTroyEvent clicked!!');
    const event = {};
    if(eventSelected === events.decodedData){
      event.id = CaptureService.getEventIds().DecodedData;
      event.type = CaptureService.getEventType().DecodedData;
      event.value = {
        id: dataSourceId.value,
        name: dataSourceId.name,
        data: decodedData.split('').map(c => c.charCodeAt(0))
      };
    }
    else if (eventSelected === events.batteryLevel) {
      event.id = CaptureService.getEventIds().BatteryLevel;
      event.type = CaptureService.getEventType().Ulong;
      event.value = 100 << 24 | batteryLevel << 8;
    }
    else if (eventSelected === events.power) {

    }
    else if (eventSelected === events.buttons) {
      const ringDetach = 0;
      const powerButton = 0;
      const middleButton = 0;
      const rightButton = 0;
      const leftButton = 0;
      event.id = CaptureService.getEventIds().Buttons;
      event.type = CaptureService.getEventType().Byte;
      event.value = ringDetach    << 4 |
                    powerButton   << 3 |
                    middleButton  << 2 |
                    rightButton   << 1 |
                    leftButton;
    }
    else if (eventSelected === events.error) {

    }
    try{
      Logger.log('about send a troy event: ', event);
      const result = await TroyService.sendTroyEvent(device.handle, event);
    }
    catch(err) {
      displayError(err, 'Error Sending an Event');
    }
  }

  const onChangeDeviceForAnswer = () => {
    devicePropertyRequests = troyDeviceSelected.propertyRequestResponses || [];
    answerToRequest = troyDeviceSelected.answerToRequest;
    if(!answerToRequest){
      const choice = answersToRequest.find(a => a.selected);
      answerToRequest = choice;
      saveAnswerToRequest = true;
    }
  };

  const onSaveAnswerToRequest = () => {
    troyDeviceSelected.answerToRequest = answerToRequest;
    const devicesAndReverseClient = [...troyDevices, reverseClient].map(d => {
      if(d.handle === troyDeviceSelected.handle){
        d.answerToRequest = answerToRequest;
      }
      return d;
    });

    const troies = devicesAndReverseClient.filter(d => d.root === false);
    const reverses = devicesAndReverseClient.filter(d => d.root === true);
    $CaptureStore.troyDevices = troies;
    $CaptureStore.rootCaptureDevices = roots
    TroyService.updateTroyDevicesList(troies);
    TroyService.updateReverseClient(reverses);
    saveAnswerToRequest = false;
  };

  const onRootPropertiesChanged = e => {
    rootProperties = e.detail;
    console.log('onRootPropertiesChanged: ', rootProperties);
  }
</script>



<h2>Capture Extension</h2>
<Section name="Reverse Client">
  <form on:submit|preventDefault={openCloseReverseClient}>
    <div class="column">
      <label>App ID
        <input bind:value={appId} disabled={reverseClient.handle}>
      </label>
      <label>Developer ID
        <input bind:value={developerId} disabled={reverseClient.handle}>
      </label>
      <label>App Key
        <input bind:value={appKey} disabled={reverseClient.handle}>
      </label>
      <!-- svelte-ignore a11y-label-has-associated-control -->
      <label>Root properties
        <InputButton selectedProperties={rootProperties} on:change={onRootPropertiesChanged}/>
      </label>
    </div>
    <div class="column">
      <label>Capture handle
        <input bind:value={captureHandle} disabled={reverseClient.handle}>
      </label>
      <label> Use WebSocket (when not using websocket, close could take up to 20s)
        <input type="checkbox" bind:checked={usingWebSocket} disabled={reverseClient.handle}>
      </label>
      <div class="bottom-right">
        <button type="submit" disabled={!captureHandle}>{openCloseLabel}</button>
      </div>
    </div>
  </form>
</Section>
<Section name="Device">
  <form on:submit|preventDefault={openTroyDevice}>
    <div class="column">
      <label>Device GUID
        <input class="refresh-button" bind:value={deviceGuid}>
      </label>
      <label>Device name
        <input bind:value={deviceName}>
      </label>
      <label>Device type
        <select bind:value={deviceType}>
          {#each deviceTypes as type}
          <option value={type}>{type.name}</option>
          {/each}
        </select>
      </label>
    </div>
    <div class="column">
      <div class="bottom-right">
        <button type="submit" disabled={!reverseClient.handle || deviceName.length === 0 || deviceType.length == 0}>Open</button>
      </div>
    </div>
  </form>
</Section>
{#each troyDevices as troyDevice}
  <Section name="Device">
    <form on:submit|preventDefault={() => closeTroyDevice(troyDevice.handle)}>
      <div class="column">
        <label>Device GUID
          <input class="refresh-button" value={troyDevice.guid} disabled="true">
        </label>
        <label>Device name
          <input value={troyDevice.name} disabled="true">
        </label>
        <label>Device type
          <input value={troyDevice.type.name} disabled="true">
        </label>
      </div>
      <div class="column">
        <div class="bottom-right">
          <button type="submit" >Close</button>
        </div>
      </div>
    </form>
    <label>Notifications
      <textarea cols="30" rows="10" value={troyDevice.notifications.join('\n')} readonly></textarea>
    </label>
  </Section>
{/each}
<Section name="Event">
  <form on:submit|preventDefault={() => sendTroyEvent(deviceSource)}>
    <div class="column">
      <label>Type of event
        <select bind:value={eventSelected}>
          {#each Object.keys(events) as eventName}
            <option value={events[eventName]}>{events[eventName].name}</option>
          {/each}
        </select>
      </label>
      {#if eventSelected === events.decodedData}
        <label>Data Source
          <select bind:value={dataSourceId}>
            {#each dataSourceIds as id}
            <option value={id}>{id.name}</option>
            {/each}
          </select>
        </label>
        <label>Decoded data
          <input bind:value={decodedData}>
        </label>
      {:else if eventSelected === events.batteryLevel}
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <label>Battery level
          <div class="same-line">
            <Slider bind:value={batteryLevel}></Slider><span>{batteryLevel}&percnt;</span>
          </div>
        </label>
      {/if}
    </div>
    <div class="column">
      <label>Device Source
        <select bind:value={deviceSource}>
          {#each troyDevices as device}
          <option value={device}>{device.name}</option>
          {/each}
        </select>
      </label>
      <div class="bottom-right">
        <button type="submit" value="Send" disabled={troyDevices.length === 0 || !deviceSource}>Send</button>
      </div>
    </div>
  </form>
</Section>
<Section name="Property Request - Response">
  <form on:submit|preventDefault={onSaveAnswerToRequest}>
    <div class="column">
      <label>Troy devices present
        <select bind:value={troyDeviceSelected} on:change={onChangeDeviceForAnswer}>
          {#each troyDevicesAndReverseClient as device}
          <option value={device}>{device.name}</option>
          {:else}
          <option value="No devices" selected="true">No devices</option>
          {/each}
        </select>
      </label>
      <label>How to answer a request
        <select bind:value={answerToRequest} on:change={() => {saveAnswerToRequest=true;}}>
          {#each answersToRequest as answer}
            <option value={answer} selected={answer.selected}>{answer.name}</option>
          {/each}
        </select>
      </label>
    </div>
    <div class="column">
      <div class="bottom-right">
        <button type="submit" disabled={!saveAnswerToRequest}>Save</button>
      </div>
    </div>
  </form>
  <label>Request - Responses
    <textarea cols="30" rows="10" value={devicePropertyRequests.join('\n')} readonly></textarea>
  </label>
</Section>
{#if error}
  <Modal>
    <div class="modal-container">
      <div class="modal-title">
        <h2>{error.title}</h2>
      </div>
      <div class="center">
        <h3>{@html error.message}</h3>
        <button on:click={()=>{error = undefined;}}>OK</button>
      </div>
    </div>
  </Modal>
{/if}

<style>
  h2 {
    margin: 10px;
  }

  label {
    display: flex;
    gap: 5px;
    margin: 5px;
    flex-direction: column;
    font-size: 1.2em;
  }
  
  input {
    padding: 5px;
    border: none;
    border-radius: 5px;
    font-size: 1.2em;
  }

  input[type=checkbox]{
    width: 35px;
    height: 35px;
  }

  button {
    padding: 10px 30px;
    font-size: 1.2em;
    border-radius: 5px;
  }

  select {
    font-size: 1.2em;
    padding: 5px;
    border-radius: 5px;
  }

  form {
    display: flex;
    gap: 10px;
  }

  .same-line {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .column {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 5px;
    min-width: 0;
  }

  .bottom-right {
    flex: 1;
    display: flex;
    flex-direction: column-reverse;
  }

  .bottom-right button {
    align-self: flex-end;
  }

  .modal-container {
    text-align: center;
    background-color: #D77C33;
  }

  .center {
    padding: 10px;
    background-color: #DDDDBE;
    border-radius: 5px;
  }

  .center button {
    margin-top: 20px;
  }

  textarea {
    width: 100%;
    font-size: 1.2em;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
    border-radius: 5px;
    resize: vertical;
  }

	@media  screen and (max-width: 812px) {
		form {
			flex-direction: column;
		}
    .bottom-right {
      position:relative;
    }
    .bottom-right button{
      position:relative;
    }
	}
</style>
